"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PayoutTypes = exports.PayoutType = void 0;
const legacy_enums_1 = require("@daytrip/legacy-enums");
Object.defineProperty(exports, "PayoutType", { enumerable: true, get: function () { return legacy_enums_1.PayoutType; } });
exports.PayoutTypes = Object.keys(legacy_enums_1.PayoutType)
    .filter((key) => !isNaN(Number(key)))
    .map((i) => Number(i));
//# sourceMappingURL=PayoutType.js.map